import { render } from "./DevBox.vue?vue&type=template&id=2d30d69a&scoped=true"
import script from "./DevBox.vue?vue&type=script&lang=js"
export * from "./DevBox.vue?vue&type=script&lang=js"

import "./DevBox.vue?vue&type=style&index=0&id=2d30d69a&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d30d69a"]])

export default __exports__